import { PcpLiveLessonState } from "../pcpLiveLessonStore.interface";
import { createSelector } from "reselect";
import { LiveSessionState } from "@pcp/core/interfaces";
import { PcpCallCompositePage } from "../../interfaces";

type PageSwitcherPageType = PcpCallCompositePage | 'expired';

const getCallCompositePage = (state: PcpLiveLessonState): PcpCallCompositePage => state.callCompositePage;
const getPcpLiveLessonState = (state: PcpLiveLessonState): LiveSessionState => state.pcpCallState;

export const selectPage = createSelector(
    [getCallCompositePage, getPcpLiveLessonState],
    (callCompositePage, pcpCallState): PageSwitcherPageType => {

        if (pcpCallState === 'ended') {
            return 'expired';
        }

        if (pcpCallState === 'expired') {
            return 'expired';
        }

        // Lobby is not implemented and is ignored.
        // Usual transition is 'configuration -> lobby -> call'.
        // Skip the lobby and redirect to 'call' directly.
        // Remove this when lobby is implemented.
        if (callCompositePage === 'lobby') {
            return 'call';
        }

        return callCompositePage;
    }
);
